module.exports = __webpack_public_path__ + "static/home-slideshow-03-c6a3935cd16db1322827bbb7a22483b2.jpg";